histories-updated-polymorphic
  span.label.label-sm(class="{opts.label-klass ? opts.label-klass : 'label-success'}" style="{opts.labelStyle}") {opts.locale.labels[opts.scope]}{ opts.label }
  shared-raw.from(content="{opts.getter(this.opts.json[opts.scope][0], this.opts.json[opts.scope2][0])}")
  span.feather.icon-arrow-left
  shared-raw.to(content="{opts.getter(this.opts.json[opts.scope][1], this.opts.json[opts.scope2][1])}")
  script(type="typescript").
    this.mixin('histories.base');
